import { useContext } from 'react'
import { FieldValues, useFormContext } from 'react-hook-form'

import { SetupPrebidStackSectionContext } from 'features/globalSetup/contexts/SetupPrebidStackSectionContext'
import { GamStatus } from 'features/globalSetup/types/gamStatus'
import { useAbility } from 'providers/casl'
import { UseCheckDisabledState } from './types'

export const useAccessibility = <Schema extends FieldValues>({
  status,
}: {
  status?: GamStatus
}): UseCheckDisabledState => {
  const ability = useAbility()
  const {
    formState: { isValid },
  } = useFormContext<Schema>()
  const { available } = useContext(SetupPrebidStackSectionContext)

  const isActionDisabled =
    !available ||
    ability.cannot('update', 'GlobalSetupFeature-googleAdManagerConnection-setupPrebidStack')

  const isSaveButtonDisabled = !available || !isValid

  const isSaveButtonVisible =
    status !== 'inProgress' &&
    ability.can('update', 'GlobalSetupFeature-googleAdManagerConnection-setupPrebidStack')

  return { isActionDisabled, isSaveButtonDisabled, isSaveButtonVisible }
}
